import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { AdditionalInfo, BoxButton } from '@repo/ui';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ErrorContactUsButtonContent = ({ clickEvent }: { clickEvent: string }) => {
  const { openChannelTalk } = useChannelTalk();
  const { sendClickEvent } = useUserEventLogger();

  const handleAsk = () => {
    sendClickEvent(clickEvent);

    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <AdditionalInfo
      className="w-full"
      info={<div className="caption-medium-regular text-neutral-foreground-low">같은 문제가 반복되시나요?</div>}
      boxButton={
        <BoxButton size="xsmall" variant="tonal-secondary" onClick={handleAsk}>
          문의하기
        </BoxButton>
      }
    />
  );
};
export default ErrorContactUsButtonContent;
